import ImportType from '../Models/ImportType';
import DataGridRequest from './DataGridRequest';
export class ImportRequest extends DataGridRequest<ImportType> {
    Url = '/account/import/api';
}
